import { Button, ButtonProps } from '@mui/material';
import { Component } from 'react';

interface ButtonWrapperProps extends ButtonProps {
    active?: boolean;
    alternativeLabel?: boolean;
    completed?: boolean;
    last?: boolean;
    expanded?: boolean;
}

export class ButtonWrapper extends Component<ButtonWrapperProps> {
    public render() {
        // throw away unsupported button props and return button
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { last, completed, alternativeLabel, active, expanded, ...buttonProps } = this.props;
        return <Button {...buttonProps} />;
    }
}
